import React, { Fragment } from 'react'
import { Message } from '@paypalcorp/worldready-react'

import { constants } from '../constants/constants'
import { constructUserNameToDisplay, removeExtraSlashes } from '../helper'
import { fileOptionsConstants } from '../constants/fileOptions'
import { fileHistoryConstants } from '../constants/fileHistoryConstants'
import { ReactComponent as FolderClose } from '../images/folder-line.svg'
import {
  renderLongFileName,
  getFormattedFilePath,
  renderLoadingSkeleton,
} from '../helpers/fileHistory'

const renderFileTypeIcon = (fileType) =>
  fileType === 'folder' ? (
    <span className="header__fileType-folder">
      <FolderClose />
    </span>
  ) : (
    <span
      className={`header__fileType-file ppvx_icon ppvx_icon--size_md ${fileOptionsConstants.Icons.file} flexCenter`}
    />
  )

const renderFileInfo = (fileName, fileType, filePath) => (
  <Fragment>
    <div className="flexAlignCenter">
      {renderFileTypeIcon(fileType)}
      <div className="header__fileName font-weight-bold w-100">{fileName}</div>
    </div>
    <div className="header__filePath w-100 flexAlignCenter">{filePath}</div>
  </Fragment>
)

const renderOwnerInfo = (userName, userType) => (
  <div className="header__owner flexAlignCenter">
    <span className="font-weight-bold">
      <Message id="filehistory.owner.label" />:
    </span>
    &nbsp;{userName}&nbsp;
    {userType}
  </div>
)

const renderTimestampOffsetSelection = (
  offset,
  disabled,
  checked,
  onChange,
  i,
) => (
  <Fragment key={i}>
    <input
      value={i}
      type="radio"
      disabled={disabled}
      name="timestamp-offset"
      checked={checked}
      className="ppvx_selection__control"
      onChange={onChange}
      id={`timestamp-offset_${offset.value}`}
    />
    <label
      className="ppvx_selection__label tooltip timeOffsetTooltip"
      htmlFor={`timestamp-offset_${offset.value}`}
    >
      {offset.label}
      <span className="tooltiptext">
        1 <Message id={`filehistory.tooltip.${offset.localizeId}`} />
      </span>
    </label>
  </Fragment>
)

const renderTimestampOffsetSelectionGroup = (
  timeOffsetIdx,
  setTimeOffsetIdx,
  isLoading,
) => {
  return (
    <fieldset className="ppvx_selection-group ppvx_selection-group__timestamp-offset">
      <div className="ppvx_selection-group__buttons">
        {fileHistoryConstants.TimestampOffsets.map((offset, i) =>
          renderTimestampOffsetSelection(
            offset,
            isLoading,
            i === timeOffsetIdx,
            () => setTimeOffsetIdx(i),
            i,
          ),
        )}
      </div>
    </fieldset>
  )
}

const getOwnerName = (isLoading, fileHistory) => {
  if (isLoading && !fileHistory) {
    return renderLoadingSkeleton()
  }
  return fileHistory.userType.toLowerCase() === constants.CorpUser ||
    fileHistory.userType.toLowerCase() === constants.GoPayUser
    ? constructUserNameToDisplay(fileHistory.userName)
    : fileHistory.userName
}

const getOwnerAccType = (isLoading, fileHistory) => {
  if (isLoading && !fileHistory) {
    return renderLoadingSkeleton()
  }
  return (
    <span className="ppvx_badge ppvx_badge--type_neutral">
      {fileHistory.userType}
    </span>
  )
}

const FileHistoryHeader = ({
  fileHistory,
  timeOffsetIdx,
  setTimeOffsetIdx,
  isLoading,
  showFileHistoryForItem,
}) => {
  const userName = getOwnerName(isLoading, fileHistory)
  const userType = getOwnerAccType(isLoading, fileHistory)
  const path = removeExtraSlashes(showFileHistoryForItem.path)
  const fileName = renderLongFileName(showFileHistoryForItem.fileName)
  const filePath = renderLongFileName(
    getFormattedFilePath(path),
    path.length > 80,
  )

  return (
    <div className="header__container">
      {renderFileInfo(fileName, showFileHistoryForItem.fileType, filePath)}
      <br />
      <div className="flexSpaceBetween">
        {renderOwnerInfo(userName, userType)}
        <div>
          {renderTimestampOffsetSelectionGroup(
            timeOffsetIdx,
            setTimeOffsetIdx,
            isLoading,
          )}
        </div>
      </div>
    </div>
  )
}

export default FileHistoryHeader
